module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "title": "Sort Items",
      "settings": _vm.settings
    }
  }, [_c('div', {
    staticClass: "pa-2"
  }, [_c('ListList', {
    ref: "list",
    attrs: {
      "items": _vm.items
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce00c6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LookupDataDialog.vue
// module id = 2567
// module chunks = 1